import { Loader } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { MomentumFeedChart } from 'features/momentum/components/Feed/Chart';
import { MomentumScore } from 'features/momentum/components/Score';
import { MomentumTrend } from 'features/momentum/components/Trend/Trend';
import { useWeekChartData } from 'features/momentum/hooks/useWeekChartData';

import { SidebarBody } from 'shared/components/Sidebar';

export const MomentumSidebarBody = () => {
  const { data, referenceDotData, latestPresentDate, isLoading } =
    useWeekChartData();

  // Show loader while momentum data is being fetched
  if (isLoading) {
    return (
      <SidebarBody>
        <Loader />
      </SidebarBody>
    );
  }

  // Find the previous day's score within the current week
  const previousDayScore = latestPresentDate
    ? (() => {
        const latestIndex = data.findIndex(
          (item) => item.date === latestPresentDate.date
        );
        // Look backwards through the current week's data for the most recent previous day with a score
        for (let i = latestIndex - 1; i >= 0; i--) {
          if (data[i]?.score !== undefined && data[i]?.score !== null) {
            return data[i].score;
          }
        }
        return undefined; // No previous day with data in current week
      })()
    : undefined;

  return (
    <SidebarBody>
      <Spacer size="lg">
        {latestPresentDate && (
          <Flex justifyContent="start" gap="var(--spacing01)">
            <MomentumScore score={latestPresentDate.score!} size="lg" />
            <MomentumTrend
              previousScore={previousDayScore}
              currentScore={latestPresentDate.score!}
            />
          </Flex>
        )}
      </Spacer>
      <MomentumFeedChart data={data} referenceDotData={referenceDotData} />
    </SidebarBody>
  );
};
